var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckBoxOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m10.444 13.556-2.388-2.39a1.05 1.05 0 0 0-.778-.305q-.472 0-.778.306a1.05 1.05 0 0 0-.306.777q0 .472.306.778l3.167 3.167q.333.333.777.333.445 0 .778-.333L17.5 9.61q.306-.306.306-.778t-.306-.777a1.05 1.05 0 0 0-.778-.306q-.472 0-.778.306zM4.222 22a2.14 2.14 0 0 1-1.57-.653A2.14 2.14 0 0 1 2 19.777V4.223q0-.915.653-1.57A2.14 2.14 0 0 1 4.223 2h15.555a2.14 2.14 0 0 1 1.57.653q.652.652.652 1.57v15.555a2.14 2.14 0 0 1-.653 1.57 2.14 2.14 0 0 1-1.57.652zm0-2.222h15.556V4.222H4.222z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBoxOutline);
export default __webpack_public_path__ + "static/media/check_box_outline.586895c34d6fe5aec809ccee8ebfb13f.svg";
export { ForwardRef as ReactComponent };